import React from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Toolbar, TabsContainer, Tabs, Tab} from 'react-md';

import ProjectList from './../Project/List';
import TestRunList from './../Project/Detail/TestRun/List';
import Index from './../Project/Detail/Index';

import './App.css';

const toolbar = <Toolbar title="TestSpell"/>;

class App extends React.Component {

render(){
   return (
    <div>
        <TabsContainer colored fixed toolbar={toolbar}>
            <Tabs tabId="1" centered>
                <Tab component={Link} label="Projects" to='/projects' className="mdc-tab" />
            </Tabs>
        </TabsContainer>
        <div className="main">
            <Switch>
                <Route exact path="/" component={ProjectList} />
                <Route exact path="/projects" component={ProjectList} />
                <Route exact path="/projects/:projectId" component={Index} />
                <Route exact path="/testRuns/:projectId" component={TestRunList} />
                <Route exact path="/testRuns" component={TestRunList} />
            </Switch>
        </div>
    </div>
   )
}

}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.js